namespace Solovis.Site.RequestNewInvestment {
  export type EntityValue = {
    name: string,
    localCurrencyId?: number,
    specialEntityTypeId?: number,
    propertyValues: Array<any /*ValueToEdit*/>,
    label: string,
    entityId: -1,
    resourceId: -1,
  }


  export class AddEntityDialog {
    public EntityEditor: Solovis.Site.RequestNewInvestment.AddEntityControl;
    public _dialogWindow: Solovis.UI.Dialog;
    private _saveCallback: (entity: EntityValue) => void;

    constructor({ saveCallback }: { saveCallback: (entity: EntityValue) => void }) {
      var self = this;

      this._saveCallback = saveCallback;

      var desiredWidth = Math.min($(window).width() * .8, 750);
      var desiredHeight = Math.min($(window).height() * .8, 800);

      var minWidth = 100;
      var minHeight = 100;

      var editorDiv = $("<div>")
        .css("min-height", "75px");

      this.EntityEditor = new Solovis.Site.RequestNewInvestment.AddEntityControl({
        controlHost: editorDiv,
      });

      this.EntityEditor.setAsCurrentControl();

      this._dialogWindow = new Solovis.UI.Dialog({
        container: editorDiv,

        title: "Add Entity",

        modal: true,
        center: true,
        actions: ["Close"],
        autoOpen: true,
        destroyOnClose: true,
        width: desiredWidth,
        height: desiredHeight,
        minWidth: minWidth,
        minHeight: minHeight,
        buttons: [
          {
            label: "Add",
            click: function () {
              self._save();
            },
          },
          {
            label: "Cancel",
            click: function () {
              self._dialogWindow.close();
            }
          }
        ],

        activate: function () {
          self.EntityEditor.focus();
        }
      });
    }


    public _cancel() {
      this._dialogWindow.close();
    }

    public _save() {
      if (this.EntityEditor.isValid()) {
        var newEntity = this.EntityEditor.getEntityModel();
        this._saveCallback(newEntity);
        this._dialogWindow.close();
      }
    }

  }

}
